/**
 * UPSELL DRAWER CAROUSEL
 * Scroll naturel horizontal des produits upsell
 */

let isUpsellSubmitting = false; // Flag pour empêcher les soumissions multiples

// Exposer globalement pour permettre la réinitialisation après re-render
window.initUpsellCarousel = function() {
  // RÉCUPÉRATION DES ÉLÉMENTS DOM
  const container = document.querySelector('.upsell-drawer-scroll');
  const pagination = document.querySelector('.upsell-drawer-pagination');
  const dots = pagination?.querySelectorAll('.upsell-drawer-pagination_dot');
  const cards = container?.querySelectorAll('.upsell-drawer-card');
  
  if (!container) return;

  // FIX: Forcer overflow-x: auto pour le scroll naturel
  container.style.overflowX = 'auto';
  container.style.overflowY = 'hidden';
  container.style.transform = 'none';

  // MISE À JOUR DES DOTS EN FONCTION DU SCROLL
  function updateDotsOnScroll() {
    if (!dots || !cards || cards.length === 0) {
      return;
    }

    // Calculer quel produit est le plus visible
    const scrollLeft = container.scrollLeft;
    const containerCenter = scrollLeft + container.offsetWidth / 2;

    let activeIndex = 0;
    let closestDistance = Infinity;

    cards.forEach((card, index) => {
      const cardCenter = card.offsetLeft + card.offsetWidth / 2;
      const distance = Math.abs(containerCenter - cardCenter);

      if (distance < closestDistance) {
        closestDistance = distance;
        activeIndex = index;
      }
    });

    // Mettre à jour les dots
    dots.forEach((dot, index) => {
      dot.classList.toggle('is-active', index === activeIndex);
    });
  }

  // Ajouter le listener de scroll
  container.addEventListener('scroll', updateDotsOnScroll);

  // Clic sur un dot → scroll vers la carte correspondante
  if (dots && cards) {
    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        if (cards[index]) {
          cards[index].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }
      });
    });
  }

  // Initialiser les dots au chargement
  updateDotsOnScroll();

  // GESTION DES FLÈCHES (PREV / NEXT)
  const prevBtn = document.querySelector('.upsell-pagination-button.prev');
  const nextBtn = document.querySelector('.upsell-pagination-button.next');

  // Mettre à jour l'état des flèches au chargement et lors du scroll
  function updateButtonStates() {
    const maxScroll = container.scrollWidth - container.offsetWidth;
    
    if (prevBtn) prevBtn.classList.toggle('disabled', container.scrollLeft <= 0);
    if (nextBtn) nextBtn.classList.toggle('disabled', container.scrollLeft >= maxScroll - 10);
  }
  
  container.addEventListener('scroll', updateButtonStates);
  updateButtonStates();

  if (prevBtn) {
    prevBtn.addEventListener('click', (e) => {
      e.preventDefault();
      container.scrollBy({ left: -300, behavior: 'smooth' });
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', (e) => {
      e.preventDefault();
      container.scrollBy({ left: 300, behavior: 'smooth' });
    });
  }

  // GESTION FORMULAIRES AJOUT PANIER ET DROPDOWNS
  
  // Gestion des dropdowns de variantes
  const variantSelects = document.querySelectorAll('.upsell-drawer-variant-select');
  
  variantSelects.forEach((select, index) => {
    select.addEventListener('change', function() {
      const productId = this.dataset.productId;
      const selectedVariantId = this.value;
      
      // Mettre à jour l'input caché du formulaire correspondant
      const variantInput = document.querySelector(`input[data-variant-input="${productId}"]`);
      
      if (variantInput) {
        variantInput.value = selectedVariantId;
      }
    });
  });
  
  // Gestion des formulaires (délégation pour survivre aux re-render du drawer)
  document.addEventListener('submit', function(e) {
    const form = e.target.closest('.upsell-drawer-form');
    if (!form) return;
    e.preventDefault();

    // ANTI-RACE-CONDITION: Vérifier si une soumission est déjà en cours
    if (isUpsellSubmitting) {
      return;
    }

    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    const button = form.querySelector('.upsell-drawer-card_add');
    const originalHTML = button ? button.innerHTML : '';
    
    // Récupérer le variant ID depuis l'input name="id"
    const variantIdInput = form.querySelector('input[name="id"]');
    const variantId = variantIdInput?.value;
    
    if (!variantId) {
      console.error('❌ Aucun variant ID trouvé dans le formulaire');
      return;
    }
    
    const quantityInput = form.querySelector('input[name="quantity"]');
    const quantity = parseInt(quantityInput?.value || '1');

    if (button) {
      // Pendant le chargement : afficher un spinner net (pas le + texte fin).
      button.innerHTML = '<span class="upsell-spinner" aria-hidden="true"></span>';
      button.classList.add('is-loading');
      button.disabled = true;
    }

    // Marquer comme en cours de soumission
    isUpsellSubmitting = true;

    try {
      const config = fetchConfig('javascript');
      
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      // Créer un FormData propre avec SEULEMENT id et quantity
      const cleanFormData = new FormData();
      
      cleanFormData.append('id', variantId);
      cleanFormData.append('quantity', String(quantity));

      if (cart && typeof cart.getSectionsToRender === 'function') {
        const sections = cart.getSectionsToRender();
        cleanFormData.append('sections', sections.map((section) => section.id));
        cleanFormData.append('sections_url', window.location.pathname);
        if (typeof cart.setActiveElement === 'function') {
          cart.setActiveElement(document.activeElement);
        }
      }
      
      config.body = cleanFormData;

      const url = `${routes.cart_add_url}`;

      fetch(url, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            console.error('Erreur API:', response.description);
            if (button) {
              button.classList.remove('is-loading');
              button.innerHTML = originalHTML;
              button.disabled = false;
            }
            isUpsellSubmitting = false;
            return;
          }

          // Mettre à jour le cart drawer avec les sections renvoyées
          if (cart && typeof cart.renderContents === 'function') {
            cart.renderContents(response);
          } else {
            // Fallback: publier un event cartUpdate
            try { 
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'upsell-drawer', cartData: response }); 
            } catch (error) {
              console.error('Erreur publication event:', error);
            }
          }

          // Réactiver le bouton après succès
          if (button) {
            button.classList.remove('is-loading');
            button.textContent = '✓';
            setTimeout(() => {
              button.innerHTML = originalHTML;
              button.disabled = false;
            }, 2000);
          }

          // Libérer le flag après un court délai
          setTimeout(() => {
            isUpsellSubmitting = false;
          }, 500);
        })
        .catch((error) => {
          console.error('Erreur lors de l\'ajout au panier:', error);
          
          if (button) {
            button.classList.remove('is-loading');
            button.textContent = '✗';
            setTimeout(() => {
              button.innerHTML = originalHTML;
              button.disabled = false;
            }, 2000);
          }
          
          // Libérer le flag en cas d'erreur
          isUpsellSubmitting = false;
        });
    } catch (error) {
      console.error('Erreur critique:', error);
      if (button) {
        button.classList.remove('is-loading');
        button.innerHTML = originalHTML;
        button.disabled = false;
      }
      isUpsellSubmitting = false;
    }
  });
};

window.initUpsellDiscounts = async function() {
  return;
};

// INITIALISATION AU CHARGEMENT
document.addEventListener('DOMContentLoaded', function() {
  window.initUpsellCarousel();
  window.initUpsellDiscounts();
});
